import { render, staticRenderFns } from "./ColorSwatches.vue?vue&type=template&id=2c1618cf&scoped=true&lang=pug&"
import script from "./ColorSwatches.vue?vue&type=script&lang=js&"
export * from "./ColorSwatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1618cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1618cf')) {
      api.createRecord('2c1618cf', component.options)
    } else {
      api.reload('2c1618cf', component.options)
    }
    module.hot.accept("./ColorSwatches.vue?vue&type=template&id=2c1618cf&scoped=true&lang=pug&", function () {
      api.rerender('2c1618cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/basic/ColorSwatches.vue"
export default component.exports